import { Component } from '@angular/core';

@Component({
  selector: 'app-dapp-icon-default',
  templateUrl: './dapp-icon-default.component.html',
  styleUrls: ['./dapp-icon-default.component.scss']
})
export class DappIconDefaultComponent {

}
